import { elakay_API } from "../../../config";

const HOW_WE_DO_IT_MEDIA_PATH = /^\/data\/(images|videos|files)\/how-we-do-it\/([^?#\s"'/]+)/i;
// The same files read through the API (GET /how-we-do-it/media/file/...).
const HOW_WE_DO_IT_MEDIA_ROUTE = /\/how-we-do-it\/media\/file\/(images|videos|files)\/([^?#\s"'/]+)/i;

const browserOrigin = () => (typeof window !== "undefined" ? window.location.origin : "http://localhost");

const apiOrigin = () => {
  try {
    return new URL(elakay_API, browserOrigin()).origin;
  } catch {
    return browserOrigin();
  }
};

// Absolute API base without trailing slash ("/elakay_api" in production is
// relative: it resolves on the site's own origin, which nginx forwards).
const apiBase = () => {
  try {
    return new URL(elakay_API, browserOrigin()).href.replace(/\/+$/, "");
  } catch {
    return `${browserOrigin()}/elakay_api`;
  }
};

// MongoDB stores Elakay-owned media as a host-independent path. External URLs
// (YouTube, Vimeo, CDN, etc.) remain untouched. A URL of the API media route
// (what the page renders) is turned back into that stored path.
export const canonicalizeHowWeDoItMediaUrl = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed) return "";
  const relativeMatch = HOW_WE_DO_IT_MEDIA_PATH.exec(trimmed);
  if (relativeMatch) return trimmed;

  let parsed;
  try {
    parsed = new URL(trimmed, trimmed.startsWith("/") ? browserOrigin() : undefined);
  } catch {
    return trimmed;
  }

  const localHosts = new Set(["localhost", "127.0.0.1", "::1"]);
  const ownHost =
    trimmed.startsWith("/") ||
    parsed.origin === apiOrigin() ||
    parsed.origin === browserOrigin() ||
    localHosts.has(parsed.hostname);
  if (!ownHost) return trimmed;

  const route = HOW_WE_DO_IT_MEDIA_ROUTE.exec(parsed.pathname);
  if (route) return `/data/${route[1].toLowerCase()}/how-we-do-it/${route[2]}`;

  const match = HOW_WE_DO_IT_MEDIA_PATH.exec(parsed.pathname);
  if (!match) return trimmed;
  return `${match[0]}${parsed.search}${parsed.hash}`;
};

// Rendering reads a stored /data/<folder>/how-we-do-it/<file> path (or an old
// absolute localhost value) through the API route. In production only
// /elakay_api/* reaches the Node server -- /data/* answers the site's
// index.html -- so this is what makes uploaded images, videos and files load
// there. Display-only: never changes an external provider URL.
export const resolveHowWeDoItMediaUrl = (value) => {
  const canonical = canonicalizeHowWeDoItMediaUrl(value);
  if (typeof canonical !== "string") return canonical;
  const match = HOW_WE_DO_IT_MEDIA_PATH.exec(canonical);
  if (!match) return canonical;
  return `${apiBase()}/how-we-do-it/media/file/${match[1].toLowerCase()}/${match[2]}`;
};
